import styled from "styled-components"

export const Button = (props: { 
    text: string,
    onClick?: () => void
}) => {

    return (
        <Root onClick={props.onClick ?? props.onClick}>{props.text}</Root>
    )
}

const Root = styled.button`
    display: block;
    font-size: 20px;
    font-weight: 900;
    color: #054654;
    width: 100%;
    padding: 8px;
    background-color: #AEDD79;
    border-radius: 8px;
    border: 0;
    border-bottom: 5px solid #4E861A;
    cursor: pointer;

    &:active{
        background-color: #90D048;
        border-bottom: 3px solid #4E861A;
        margin-top: 2px;
    }
`;